import React, { useState, useEffect, useRef } from 'react';
import './index.scss';

const AboutCarousel = ({ className, data }) => {
  const carousel = useRef(null);
  const [ enable, setEnable ] = useState(true);
  const [ currentIndex, setCurrentIndex ] = useState(0);
  const [ prevIndex, setPrevIndex ] = useState(0);
  const [ status, setStatus ] = useState('');

  useEffect(() => {
    window.addEventListener('wheel', handleWatchScroll, { passive: false });
    return () => window.removeEventListener('wheel', handleWatchScroll);
  }, []);

  useEffect(() => {
    carousel.current.currentIndex = currentIndex;
    carousel.current.prevIndex = prevIndex;
  }, [currentIndex, prevIndex]);

  useEffect(() => {
    carousel.current.enable = enable;
  }, [enable]);

  const handleWatchScroll = (e) => {
    if (carousel.current.enter && carousel.current.enable) {
      if (e.deltaY < 0 && carousel.current.currentIndex !== 0) {
        e.preventDefault();
        handleSelectSection(carousel.current.currentIndex, Math.max(carousel.current.currentIndex-1, 0))
      };
      if(e.deltaY > 0 && carousel.current.currentIndex !== data.length-1) {
        e.preventDefault();
        handleSelectSection(carousel.current.currentIndex, Math.min(carousel.current.currentIndex+1, data.length-1))
      };
    }
  }

  const handleSelectSection = (prevIndex, index) => {
    if (enable) {
      setEnable(false);
      setStatus(index > prevIndex ? 'up' : 'down');
      setCurrentIndex(index);
      setPrevIndex(prevIndex);
      setTimeout(() => setEnable(true), 300);
    }
  }

  return (
    <div className="about-carousel" ref={carousel}
      onMouseLeave={e => carousel.current.enter = false}
      onMouseEnter={e => carousel.current.enter = true}>
      <div className="controller">
        <button className="prev" onClick={() => currentIndex!==0 && handleSelectSection(currentIndex, currentIndex-1)}></button>
        <button className="next" onClick={() => currentIndex!==data.length-1 && handleSelectSection(currentIndex, currentIndex+1)}></button>
      </div>
      <div className="dots">
        {
          data.map((item, i) => 
            <button className="dot" disabled={currentIndex === i} 
            onClick={() => handleSelectSection(currentIndex, i)} key={i}></button>
          )
        }
      </div>
      <div className="space item">
        <div className={`section`}>
          <div className="side">
            <div className="title type-heading -en -h2">{ data[0].title }</div>
            <div className="label type-text -ch -lg">{ data[0].label }</div>
            <div className="content type-text -ch -md">{ data[0].content }</div>
          </div>
          <div className="illustration">
            <img src={data[0].illustration} alt="" />
          </div>
        </div>
      </div>
      <div className="carousel">
        {
          data.map((item, i) =>
          <div key={i} className={`item 
            ${item.last ? '-last' : ''} 
            ${currentIndex === i ? '-active' : ''} 
            ${prevIndex === i ? '-stay' : ''} 
            ${currentIndex === i && status === 'up' ? '-up' : ''} 
            ${prevIndex === i && status === 'down' ? '-down' : ''} 
          `}>
            {
              <React.Fragment>
                {
                  item.last ?
                  <div className="text-board">
                    <div className="type-heading -ch -h2">
                    </div>
                  </div>
                  :
                  <div className={`section`}>
                    {
                      item.dots &&
                      <div className="cover">
                        <div className="type-heading -ch -h2">
                          <p>{ item.dots && item.dots.map((item, i) => <span className="dot" key={i}>{item}</span>) }</p>
                          <span>{ item.heading }</span>
                          <span className="hide">{ item.hide }</span>
                        </div>
                      </div>
                    }
                    <div className={`side ${item.dots ? '-hidden' : ''}`}>
                      <div className="title type-heading -en -h2">{ item.title }</div>
                      <div className="label type-text -ch -lg">{ item.label }</div>
                      <div className="content type-text -ch -md">{ item.content }</div>
                    </div>
                    <div className="illustration">
                      <img src={item.illustration} alt="" />
                    </div>
                  </div>
                }
              </React.Fragment>
            }
          </div>
          )
        }
      </div>
    </div>
  )
}

export default AboutCarousel;